import script from "./UploadFilePDF.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadFilePDF.vue?vue&type=script&lang=ts&setup=true"

import "./UploadFilePDF.vue?vue&type=style&index=0&id=6a8154b1&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a8154b1"]])

export default __exports__